export enum DirectionsType {
    doctor = 'doctor',
    client = 'cliente',
    default = ''
}

export enum DirectionsTypeCreate {
    doctor = 'doctor',
    client = 'cliente',
    default = ''
}

export enum Routes {
    allDirections = '/shippinginfo',
    someDirections = '/responsible/shippinginfo'
  }
